import { Link } from "@whitespace/components";
import { apartmentContext } from "@whitespace/gatsby-plugin-smorgasbord-fastapi";
import {
  Action,
  ErrorMessage,
  Loading,
} from "@whitespace/gatsby-theme-smorgasbord/src/components";
import { format, parseISO } from "date-fns";
import React, { useContext } from "react";
import { useTranslation, Trans } from "react-i18next";

import AptusContext from "../contexts/aptusContext";
import useAptusBooking from "../hooks/useAptusBooking";

async function handleAddToCalendar() {
  // @TODO Create add to calendar functionality
  console.log("add to calendar");
}

export default function NextBookingAction() {
  const { t } = useTranslation();
  const { nextBooking, setBookings } = useContext(AptusContext);

  const { del, error, response, loading } = useAptusBooking({
    headers: {
      "Content-Type": "application/json",
    },
  });
  const { selectedApartment } = useContext(apartmentContext);

  async function handleCancelBooking() {
    const { bookingId } = nextBooking;
    await del(`/apartments/${selectedApartment.id}/bookings`, {
      bookingId,
    });
    if (response.ok) {
      setBookings([]); // Clear entire array to fetch all bookings again from API
    }
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorMessage error={error} />;
  }

  if (!nextBooking) {
    return null;
  }

  const groupName = nextBooking.groupName;

  const date = parseISO(nextBooking.startTime).toLocaleDateString("sv", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
  const startTime = parseISO(nextBooking.startTime);
  const time = startTime.toLocaleTimeString("sv", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <Action
      label={
        <Trans i18nKey="bookingMessage">
          You have booked <strong>{{ groupName }}</strong> on{" "}
          <strong>{{ date }}</strong> at <strong>{{ time }}</strong>.
        </Trans>
      }
    >
      {/* <Link onClick={() => handleAddToCalendar()}>{t("addToCalendar")}</Link> */}
      <Link onClick={() => handleCancelBooking()}>{t("cancel")}</Link>
    </Action>
  );
}
